import { ColoredTypography } from 'components/ColoredTypography';
import { FormattedMessage } from 'react-intl';

export const ShortcutHint = () => (
  <ColoredTypography variant="caption" color="blackMediumEmphasis">
    <FormattedMessage id="chat.message_input.new_line_shortcut" />
  </ColoredTypography>
);
